import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { QueryKeys } from "../queryKeys";


export type GetCardBinByBankCodeRequest = {
  bankCode: string;
};


async function getCardBinByBankCode({ bankCode }: GetCardBinByBankCodeRequest): Promise<any> {
  try {
    const data = {
      bankCode
    };
    return (await axiosInstance.post("/CardBin/CardBinByBankCode", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetCardBinByBankCode(bankCode:string) {
  return useQuery(
    [QueryKeys.GetCardBinByBankCode, bankCode],
    () => getCardBinByBankCode({ bankCode }),
    {
      cacheTime: Infinity,
      enabled: !!bankCode 
    }
  );
}